var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container"},[(!_vm.isListView)?_c('label',{staticClass:"button-label"},[_vm._v(" "+_vm._s(_vm.$t('processingStatus'))+" ")]):_vm._e(),_c('button',{on:{"click":_vm.handleClick}},[_c('img',{style:(_vm.iconStyle),attrs:{"src":_vm.inventarioOficial ? _vm.imgOficial : _vm.imgNaoOficial,"alt":"Ícone"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }